interface API_RESPONSE {
    data: any[];
    errors?: string[];
    message: string;
    status: boolean;
  }
  interface SignUpPayload {
    full_name: string;
    mobile_number: string;
    email: string;
    password: string;
  }
  
  interface LoginPayload {
    email?: string;
    username?: string;
    password: string;
  }

  interface RGProduct {
    id?: string;
    grant_name: string;
    grant_id: string;
    logo: string;
    fund_value: string;
    grant_amount: string;
    tenure: string;
    monthly_emi_amount: string;
    deferment_period: string;
    status: 'draft' | 'active';
  }
  
  interface ProviderSearchPayload {
    age: number,
    gender: string,
    location: string
  }

  interface ProductParams {
    borrowerId : string,
    age: number,
    gender: string,
    location: string
  }

  interface RefreshTokenPayload {
    refresh: string;
  }

  interface SendVerifyOtpPayload {
    mobile_number: string;
    otp?: string;
  }

  interface UPLOAD_DOCUMENT_DATA {
    modalTitle: string;
    fieldName: string;
    submitButtonLabel: string;
    cancelButtonLabel: string;
    dataRequired: {
      panCardNumber: boolean;
      aadharCardNumber: boolean;
      pan_file: boolean;
    }
  }

  interface S3_DOCUMENT_DATA {
    pan_card_image : File;
  }
  interface PAN_CARD_UPLOAD {
    pan_image_url: string;
    user_id: string;
    user_type: 'borrower' | 'agent';
    pan_card_number: string;
    aadhar_card_number: string;
  }

  interface ProviderInitPayload {
    transaction_id: string;
    bpp_id: string;
    bpp_uri: string;
    provider_id: string;
    selected_product: any;
    participant_id: string;
    agent_kyc_reference_number?: string;
    borrower_kyc_reference_number?: string;
  }

  interface ProviderConfirmPayload {
    transaction_id: string;
    bpp_id: string;
    bpp_uri: string;
    provider_id: string;
    participant_id: string;
    selected_product: any;
    agent_kyc_reference_number: string;
    borrower_kyc_reference_number: string;
  }

  interface Borrower {
    id: string;
    first_name: string;
    last_name: string;
    dob: string;
    gender: string;
    mobile_number: string;
    email: string;
    address_line_1: string;
    address_line_2: string;
    state: string;
    district: string;
    city: string;
    village: string;
    pincode: string;
    aadhar_card_number: string;
    pan_card_number: string;
    bank_account_holder_name: string;
    bank_name: string;
    bank_account_number: string;
    bank_ifsc_code: string;
    bank_branch: string;
    bank_account_type: string;
    created_at: string;
    updated_at: string;
    agent: string;
    pan_image_link: string;
    kyc_reference_number?: string;
    samhita_participant_id?: string;
  }
  interface PaymentDetails {
    order_status: string;
    grant_amount: string;
    order_id: string;
    order_date: string;
    order_time: string;
    transaction_id: string;
  }

  enum LoadingType {
    BUBBLES = 'bubbles',
    CIRCLES = 'circles',
    CIRCULAR = 'circular',
    CRESCENT = 'crescent',
    DOTS = 'dots',
    LINES = 'lines',
    LINES_SHARP = 'lines-sharp',
    LINES_SHARP_SMALL = 'lines-sharp-small',
    LINES_SMALL = 'lines-small'
}

enum SESSION_STORAGE_KEYS {
  ACTIVE_CONTEXT = 'active_context',
  SESSION_TOKEN = 'sessionToken',
  USER_INFO = 'userInfo',
  TRANSACTION_ID = 'transaction_id',
  SUCCESS_ORDER = 'success_order',
  SELECTED_GRANT = 'selected_grant',
  AADHAAR_VERIFICATION_IN_PROGRESS = 'aadhaar_verification_in_progress',
}

interface LoadingMessage {
  endpoint: string;
  method: string;
  message: string;
}

interface BackButtonEvent {
  register: (id: number, callback: () => void) => void;
}

interface CustomerRegistrationPayload {
  customer_reference_number: string;
  mobile_number: string;
  appreciate_terms_and_conditions: boolean;
}

interface CustomerRegistrationResponse {
  status: boolean;
  message: string;
  data: {
    u_ref_number: string;
    kyc_status: string;
    completed_stages: string[];
    b2b_customer_id: string;
  };
  error_status: {
    error_code: string;
  };
}

interface PanVerificationPayload {
  u_ref_num: string;
  name_on_pan: string;
  date_of_birth: string;
  pan_number: string;
}

interface PanVerificationResponse {
  status: boolean;
  message: string;
  data: {
    u_ref_num: string;
    pan_number: string;
    name_on_pan: string;
    date_of_birth: string;
  };
}

interface PoaVerificationPayload {
  u_ref_num: string;
  aadhaar_consent: boolean;
}

interface PoaVerificationResponse {
  message: string;
  data: {
    aadhaar_verification_link: string;
    kyc_status: string;
  };
  status: boolean;
  error_status: {
    error_code: string;
  };
}

interface PoaVerificationStatusPayload {
  u_ref_num: string;
  aadhaar_consent: boolean;
}

interface PoaVerificationStatusResponse {
  status: boolean;
  message: string;
  data: {
    aadhaar_verification_status: string;
    kyc_status?: string;
  };
  error_status?: {
    error_code: string;
  };
}

interface KycStatusPayload {
  kyc_reference_number?: string;
  mobile_number: string;
}

interface KycStatusResponse {
  status: boolean;
  message?: string;
  data?: {
    kyc_status?: string;
    u_ref_number?: string;
    kyc_reference_number?: string;
  };
  error_status?: {
    error_code: string;
  };
}

export interface SelectRgProductPayload {
  participant_id: string;
  project_id: string;
  rg_product_id: string;
  project_name: string;
}

export interface SelectRgProductResponse {
  participant_id: string;
  project_id: string;
  rg_product_id: string;
  is_selected: boolean;
  rg_product_details?: RGProduct;
}

/** Payload for POST /kyc/account-verification/ */
export interface AccountVerificationPayload {
  kycRefNumber: string;
  accountNumber: string;
  ifscCode: string;
  userName: string;
  mobileNumber: string;
  grantName: string;
  grantDuration: string;
  defermentPeriod: string;
  disbursalAmount: string;
  monthlyRepaymentAmount: string;
  repaymentDate: string;
}

/** Response from POST /kyc/get-tenant-access-token/ */
export interface TenantAccessTokenResponse {
  Status: boolean;
  Message: string;
  Type: string;
  ErrorStatus?: {
    ErrorCode: string;
    Message: string;
  };
  Data?: {
    access_token: string;
    expires_in: number;
    refresh_expires_in: number;
    token_type: string;
    'not-before-policy': number;
    scope: string;
  };
}

/** Grant item from rg-products API (label: name, value: id) */
export interface Grant {
  id: string;
  grant_id?: string;
  project_id?: string;
  project_name?: string;
  grant_name: string;
  fund_value?: string;
  monthly_emi_amount: string;
  tenure: string;
  grant_amount: string;
  deferment_period: string;
  created_at?: string;
}

/** API response for GET beckn/rg-products/ */
export interface RgProductsApiResponse {
  count?: number;
  data: Grant[];
}

export interface ParticipantGrantProject {
  project_id: string;
  project_name: string;
  rg_product_id: string[];
}

export interface ParticipantGrantDetailsApiResponse {
  status: string;
  message: string;
  data: ParticipantGrantProject[];
  errors: string[] | null;
}
  
export { API_RESPONSE , SignUpPayload , LoginPayload , ProviderSearchPayload , Borrower , PaymentDetails , ProviderInitPayload , RefreshTokenPayload , LoadingType , LoadingMessage, ProviderConfirmPayload, SendVerifyOtpPayload , BackButtonEvent , SESSION_STORAGE_KEYS, ProductParams, UPLOAD_DOCUMENT_DATA, S3_DOCUMENT_DATA, PAN_CARD_UPLOAD, RGProduct, CustomerRegistrationPayload, CustomerRegistrationResponse, PanVerificationPayload, PanVerificationResponse, PoaVerificationPayload, PoaVerificationResponse, PoaVerificationStatusPayload, PoaVerificationStatusResponse, KycStatusPayload, KycStatusResponse}